import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function LedgerIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6641 9.33398C10.6641 9.88625 11.1118 10.334 11.6641 10.334C12.2163 10.334 12.6641 9.88625 12.6641 9.33398C12.6641 8.78172 12.2163 8.33398 11.6641 8.33398C11.1118 8.33398 10.6641 8.78172 10.6641 9.33398Z"
        stroke="currentColor"
        fill="none"
      />
      <path
        d="M12.5971 5.33398C12.6408 5.11858 12.6637 4.89563 12.6637 4.66732C12.6637 2.82637 11.1713 1.33398 9.3304 1.33398C7.48947 1.33398 5.99707 2.82637 5.99707 4.66732C5.99707 4.89563 6.02002 5.11858 6.06375 5.33398"
        stroke="currentColor"
        fill="none"
      />
      <path
        d="M4.66341 5.32818H10.6634C12.549 5.32818 13.4918 5.32818 14.0776 5.91424C14.6634 6.50032 14.6634 7.44355 14.6634 9.33008V10.6641C14.6634 12.5506 14.6634 13.4939 14.0776 14.0799C13.4918 14.666 12.549 14.666 10.6634 14.666H6.66341C4.14925 14.666 2.89218 14.666 2.11112 13.8846C1.33008 13.1031 1.33008 11.8455 1.33008 9.33008V7.99615C1.33008 5.48076 1.33008 4.22307 2.11112 3.44164C2.73985 2.81262 3.67703 2.68994 5.33008 2.66602H6.66341"
        stroke="currentColor"
        strokeLinecap="round"
        fill="none"
      />
    </SvgIcon>
  );
}
